import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
  cbtn: '确定',
  headerInfo: {
    title: 'BLOOM评委管理系统',
    changePsd: '修改密码',
    logout: '退出',
    SelectActivity: '选择活动'
  },
  downLoad: '下载',
  total: '当前字数',
  loginPage: {
    title: '评委管理系统',
    account: '帐号登录',
    phoneSecurity: '手机验证码登录',
    enterNuber: '请输入手机号',
    psd: '请输入6-16位登录密码',
    smsCode: '请输入验证码',
    login: '登录',
    changePsd: '修改密码',
    longTxt: '为了保护你的帐号安全，首次登陆后请立即修改密码',
    enterPsd: '请输入新密码',
    reEnter: '请再次输入新密码',
    authentication: '身份验证',
    alert: {
      success: '发送成功',
      subMitSus: '提交成功',
      changeSuc: '修改成功'
    },
    sendSms: {
      is: '发送验证码',
      not: '后重新获取'
    }
  },
  operatingSystem: {
    index: {
      list: {
        workManage: '作业评审',
        workCorrecting: '试卷批改'
      }
    },
    total: '共',
    count: '条',
    listPage: {
      placeholder: {
        activity: '选择活动季',
        workType: '请选择作业类型',
        workName: '请选择任务名称',
        isReview: '请选择评审状态',
        isPass: '请选择是否通过',
        teamName: '请输入团队名称',
        teamNum: '请输入团队编号',
        studentName: '请输入姓名',
        describe: '请描述',
        score: '请输入分数（0-100分）',
        reviewOpinion: '请填写评语'
      },
      label: {
        workType: {
          one: '个人作业',
          two: '团队作业'
        },
        isReview: {
          one: '未评审',
          two: '已评审'
        },
        isPass: {
          one: '未通过',
          two: '通过'
        },
        isCheat: {
          one: '是',
          two: '否'
        },
        serial: '序号',
        teamName: '团队名称',
        studentName: '姓名',
        firstName: '拼音名',
        lastName: '拼音姓',
        teamNum: '团队编号',
        schoolName: '学校名称',
        taskName: '任务名称',
        submitTime: '提交时间',
        reviewStatus: '评审状态',
        reviewTime: '评审时间',
        isPassText: '是否通过',
        score: '分数',
        reviewOpinion: '评语',
        reviewOpinion2: '评语[选填]',
        action: '操作',
        edit: '评审'
      },
      btn: {
        search: '搜索',
        batchreview: '批量评审',
        export: '导出作业',
        scan: '查看',
        edit: '评审',
        cancle: '取 消',
        submit: '提 交',
        again: '再检查下'
      },
      dialog: {
        title: '评审记录',
        againTitle: '确定提交吗？',
        isPass: '是否通过：',
        score: '分数：',
        reviewOpinion: '评语：',
        againTxt: '请检查下是否已完成所有打分'
      },
      alert: {
        one: '请先选择需要评审的作业',
        two: '此作业不支持批量评审，请前往作业详情进行单个评审。'
      }
    },
    infoPage: {
      none: '无',
      title: {
        main: '作业详情',
        edit: '编辑',
        mainDetail: '作业详情',
        basic: '个人基本信息',
        team: '团队基本信息',
        work: '作业信息',
        check: '审批信息',
        review: '评审',
        reviewList: '评审记录'
      },
      form: {
        taskName: '作业名称',
        workDetail: '作业内容',
        uploadFile: '上传文件',
        preview: '预览',
        download: '下载',
        judgeName: '评委',
        isCheatTxt: '是否作弊',
        scanList: '查看评审记录',
        tips: '您的浏览器不支持 video 标签。',
        downLoadAll: '下载全部文件',
        reviewUser: '评审',  // 评审人
        scoreRequired: '所有评审内容均为必填项，请填写完后再提交'
      },
      btn: {
        check: '评 审'
      }
    },
    testList: {
      selectTest: '请选择考试',
      selectSuccessStatus: '请选择完成状态',
      finished: '已完成',
      unfinished: '未完成',
      search: '搜索',
      index: '序号',
      test: '考试',
      progress: '批改进度',
      finishStatus: '完成状态',
      deadline: '截止时间',
      actions: '操作',
      access: '查看试卷列表'
    },
    paperList: {
      selectName: '请输入姓名',
      selectReviewStatus: '请选择批改状态',
      name: '姓名',
      reviewStatus: '批改状态',
      lastReviewTime: '最新批改时间',
      review: '批改',
      view: '查看',
      reviewed: '已批改',
      unreviewed: '未批改',
      noExam: '该考试已不存在'
    },
    paperDesc: {
      total1: '共计',
      name: '姓名',
      Writing: '写作题',
      score: '分',
      questions1: '题',
      questions: '共',
      fullScore: '满分：',
      score1: '得分：',
      submit: '提交批改结果',
      Previous: '上一张试卷',
      Next: '下一张试卷',
      resultChange: '批改结果已发生变更，请提交后再切换试卷',
      reassigned: '试卷已重新分配',
      Refresh: '刷新',
      successfully: '提交成功',
      failed: '提交失败，请重试',
      noResult: '请完成所有题目的评分后再提交批改结果',
      stopSubmit: '批改已截止，无法提交批改结果',
      tips: '提示',
      tipContent: '当前批改结果尚未提交，确定离开吗？',
      confirm: '确定',
      cancel: '取消'
    },
    router: {
      testList: '考试列表',
      testPaperList: '试卷列表',
      testPaper: '试卷'
    }
  },
  ...zhLocale
}
export default zh



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh.js